import "./style.less";
import imgBoldspil from "./assets/Boldspil_s.jpg";
import imgBadminton from "./assets/Badminton_s.jpg";
import imgVolley from "./assets/moede.jpg";

export default function shortcutCards() {
    return {
        restrict: "E",
        scope: {},
        replace: false,
        template: require("./template.html"),

        controller: function ($scope, moment) {
            const today = moment().format("DD-MM-YYYY");
            $scope.searchToday = `?date=${today}&start=6&end=23&hours=1`;
        },
    };
}
